import { FC } from "react";

import styles from "./borderedIconedTextblock.module.scss";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TBorderedIconedTextblockProps = {
    text: string,
    icon?: IconDefinition,
    iconClassName?: string,
    backgroundColor?: string
    borderColor?: string
    color?: string,
    title?: string,
    className?: string,
    onMouseUpHandler?: (mouseEvent: React.MouseEvent<HTMLElement, MouseEvent>) => void,
    onIconClick?: (mouseEvent: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
};

export const BorderedIconedTextblock: FC<TBorderedIconedTextblockProps> = ({ backgroundColor, borderColor, color, text, icon, iconClassName, title, onMouseUpHandler, className, onIconClick }: TBorderedIconedTextblockProps) => {

    let usedBorderColor: string | undefined = undefined;
    if(borderColor) {
        usedBorderColor = borderColor;
    } else if(backgroundColor) {
        usedBorderColor = backgroundColor;
    }

    return (
        <span
            style={{backgroundColor: backgroundColor, color: color, borderColor: usedBorderColor}} 
            className={`${styles.borderedIconedTextblock} ${className ? className : ""}`}
            title={title}
            onMouseUp={onMouseUpHandler}
        >
            {icon ? <FontAwesomeIcon icon={icon} className={iconClassName ? iconClassName : ""} onClick={onIconClick} /> : <></>}
            {text}
        </span>
    );
};